import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycCreationOfALifeEstatePage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-creation-of-a-life-estate/']} />;
}
